// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IssueStatusController from "./issue_status_controller"
application.register("issue-status", IssueStatusController)

import OccurrenceController from "./occurrence_controller"
application.register("occurrence", OccurrenceController)

import ResponseTimeChartController from "./response_time_chart_controller"
application.register("response-time-chart", ResponseTimeChartController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
